import { html } from "lit";
import { formatHtml } from "@trumpf/ux.common-storybook";
export default {
    title: "MyTrumpf/Partial Templates/Bending Tools",
    parameters: {
        docs: {
            source: {
                transform: formatHtml,
            },
        },
    },
};

const Template = () => {
    return html`
        <div class="ux-row">
            <div class="ux-col-12 ux-col-md-10 ux-u-offset-md-1 ux-u-mt-l">
                <!-- BEGIN results-table -->
                <ux-table
                    fixed-col-index="0"
                    full-width
                    has-fixed-link
                    sortable
                >
                    <table id="bending-tools-table">
                        <thead>
                            <tr>
                                <th>
                                    <ux-table-sort
                                        asc-name="name-asc"
                                        desc-name="name-desc"
                                        >Bezeichnung</ux-table-sort
                                    >
                                </th>
                                <th>
                                    <ux-table-sort
                                        asc-name="format-asc"
                                        desc-name="format-desc"
                                        >Dateiformat / Version</ux-table-sort
                                    >
                                </th>
                                <th>
                                    <ux-table-sort
                                        asc-name="system-asc"
                                        desc-name="system-desc"
                                        >Offline Programmiersystem
                                    </ux-table-sort>
                                </th>
                                <th>
                                    <ux-table-sort
                                        asc-name="machine-control-asc"
                                        desc-name="machine-control-desc"
                                        >Maschinensteuerung
                                    </ux-table-sort>
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>V150 (aktuellste Version)</td>
                                <td>Arv / 15.0</td>
                                <td>
                                    ab TruTops V6.0 / TruTops Boost 1.0 / ab
                                    TecZoneBend 17.00
                                </td>
                                <td>
                                    ab TASC / MMI Version 8.3 und Touchpoint 1.0
                                </td>
                            </tr>

                            <tr>
                                <td>V415</td>
                                <td>Arv / 4.15</td>
                                <td>
                                    ab TruTops Bend Version 4.15
                                </td>
                                <td>
                                    ab TASC / MMI Version 7.0
                                </td>
                            </tr>

                            <tr>
                                <td>V411</td>
                                <td>Arv / 4.11</td>
                                <td>
                                    ab TruTops Bend Version 4.11
                                </td>
                                <td>
                                    ab TASC / MMI Version 4.5
                                </td>
                            </tr>

                            <tr>
                                <td>DLD, DXF, PDF</td>
                                <td>DLD, DXF, PDF</td>
                                <td></td>
                                <td>
                                    DELEM
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </ux-table>
            </div>
        </div>
    `;
};

export const Default = Template.bind({});
